import { Component } from '@angular/core';

@Component({
  selector: 'bor-privacy',
  standalone: false,
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss',
})
export class PrivacyComponent {}
